// @core/api/endpoints/affiliate/process_payout.ts
// Auto-generated by corebuilder. DO NOT EDIT.

import { getApiClient, type RequestOptions } from '../../client';
import type {
  PayoutResponse,
  ProcessPayoutRequest,
} from '../../../types/affiliate';

const BASE_PATH = '/affiliate';

/**
 * Process payout via BillingService
 * Creates a Transaction in BillingService to execute the payout.
 */
export async function ProcessPayout(
  payout_id: string,
  data: ProcessPayoutRequest,
  options?: RequestOptions
): Promise<PayoutResponse> {
  const client = getApiClient();
  let requestPath = `${BASE_PATH}/payouts/:payout_id/process`;
  requestPath = requestPath.replace(':payout_id', encodeURIComponent(payout_id));
  const requestOptions = options;
  return client.post<PayoutResponse>(requestPath, data, requestOptions);
}
